module.exports = __webpack_public_path__ + "img/Leap Learning-WritingCastle.9a3a5105.png";